$(() => {
  const $body = $("body"),
    $html = $("html"),
    $header = $("header");

  const scrollTop = () => {
    const scroll = $(window).scrollTop();
    if (scroll >= 32) {
      $header.addClass("scrolled");
      $body.addClass("header-scrolled");
    } else {
      $header.removeClass("scrolled");
      $body.removeClass("header-scrolled");
    }
    if ($("#wpadminbar").length) {
      if (scroll >= 10) {
        $body.addClass("enabled-admin-bar-on-scroll");
      } else {
        $body.removeClass("enabled-admin-bar-on-scroll");
      }
    }
  };

  $(window).on("load scroll", () => {
    scrollTop();
  });

  $(".bs-column--footer-social-share .social-wrapper").clone().appendTo(".bs-column--footer-logo-column");

  $(".menu-item-has-children").each((index, element) => {
    $(element).children("a").append('<span class="drop-down-helper"></span>');
  });

  $(".current-menu-ancestor").each((index, element) => {
    $(element).addClass("active-menu-item").children(".sub-menu").slideDown(600);
  });

  $("footer .navbar-nav > .menu-item-has-children > a").on("click", (e) => {
    const $this = $(e.target);
    e.preventDefault();
    $this.closest("li").toggleClass("active-menu-item");
    if ($this.closest("li").hasClass("active-menu-item")) {
      $this.closest("li").children(".sub-menu").slideDown(600);
    } else {
      $this.closest("li").children(".sub-menu").slideUp(600);
    }
  });

  /* Header navigation  */
  const topMenu = $("#mega-menu-top-menu li");
  const mainMenu = $("#mega-menu-main-menu");
  let liItems = [];
  let fullItems = [];
  const liCount = topMenu.length - 2; // ignore last two items
  // top menu list items push to array for use
  for (let i = 0; i < topMenu.length; i++) {
    if (i + 1 <= liCount) {
      liItems.push(topMenu[i]);
    }
    fullItems.push(topMenu[i]);
  }

  // Social media links for headers
  const socialElem = $(".social-wrapper");
  const socialHtml = `<div class="mobile-social-items">${socialElem.html()}</div>`;

  const headerTopNavigationBehavior = (deviceWidth) => {
    if (deviceWidth.matches) {
      appendItems(liItems, mainMenu);
      $(".main-menu-wrapper").append(socialHtml); // header social links
    } else {
      $(".mobile-social-items").remove();
      const topMenuParent = $("#mega-menu-top-menu");
      topMenuParent.html("");
      appendItems(fullItems, topMenuParent);
    }
  };

  const appendItems = (obj, elem) => {
    for (let mnItem = 0; mnItem < obj.length; mnItem++) {
      elem.append(obj[mnItem]);
    }
  };

  const deviceWidth = window.matchMedia("(max-width: 991px)");
  headerTopNavigationBehavior(deviceWidth); // Call listener function at run time
  deviceWidth.addEventListener("change", () => {
    headerTopNavigationBehavior(deviceWidth);
  }); // Attach listener function on state changes

  $("main").each((index, element) => {
    const $itemCat = $(element).attr("data-category");
    if ($itemCat !== undefined && $itemCat != "") {
      const $activeMenu = $(`.menu-item.${$itemCat}, .mega-menu-item.${$itemCat}`);
      $activeMenu.addClass("current-menu-item mega-current-menu-item").children("a").addClass("enable-pointer");
      $activeMenu.parents(".menu-item, .mega-menu-item").addClass("enable-pointer current-menu-parent mega-current-menu-parent mega-current-menu-ancestor").children("a").addClass("enable-pointer");
    }
  });

  // get current scroller position
  const getYPosition = () => {
    const top = window.pageYOffset || document.documentElement.scrollTop;
    return top;
  };
  let oldPos = 0; // store scroll location before click
  const megaMenu = $(".mega-menu-toggle");
  const headerNav = $("#header.nav");
  megaMenu.on("click", (e) => {
    const topPos = getYPosition();
    if ($("#mega-menu-main-menu").is(":visible")) {
      // add styles to body if mega-menu is visible
      oldPos = topPos;
      if (topPos != 0) {
        // add styles to body if current scroll position is not 0
        $("body").css({ position: "fixed", width: "100%", top: "-" + topPos + "px", let: "0", height: "100%", overflow: "hidden" });
        headerNav.addClass("mega-opened"); // add class for backend styles
      }
    } else {
      $("body").removeAttr("style"); // remove body styles after close mega-menu
      headerNav.removeClass("mega-opened");
      window.scrollTo(0, oldPos); // scroll to same position after body fix
      oldPos = 0; // reset window old scrolled position
    }
  });
});
